import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
  createConsumoMeta,
  deleteConsumoMeta,
  getConsumoMeta,
  updateConsumoMeta,
} from '../api/consumoMetaApi'
import type { ConsumoMetaCreateInput, ConsumoMetaFilters, ConsumoMetaUpdateInput } from '../types/consumoMeta'

export const consumoMetaKeys = {
  all: ['consumo-meta'] as const,
  lists: () => [...consumoMetaKeys.all, 'list'] as const,
  list: (filters?: ConsumoMetaFilters) => [...consumoMetaKeys.lists(), { filters }] as const,
}

export function useConsumoMeta(filters?: ConsumoMetaFilters) {
  return useQuery({
    queryKey: consumoMetaKeys.list(filters),
    queryFn: () => getConsumoMeta(filters),
  })
}

export function useCreateConsumoMeta() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: ConsumoMetaCreateInput) => createConsumoMeta(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consumoMetaKeys.lists() })
      toast.success('Registro creado exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear registro')
    },
  })
}

export function useUpdateConsumoMeta() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ConsumoMetaUpdateInput }) =>
      updateConsumoMeta(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consumoMetaKeys.lists() })
      toast.success('Registro actualizado exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar registro')
    },
  })
}

export function useDeleteConsumoMeta() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteConsumoMeta(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consumoMetaKeys.lists() })
      toast.success('Registro eliminado')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar registro')
    },
  })
}
